const MAPS_URL = 'https://api.rainviewer.com/public/weather-maps.json';

/**
 * @typedef {{ t: number, path: string, host: string, img?: HTMLImageElement }} RadarFrame
 */

export async function fetchRadarFrames() {
  const res = await fetch(MAPS_URL, { cache: 'no-cache' });
  if (!res.ok) throw new Error(`RainViewer ${res.status}`);
  const data = await res.json();
  const host = String(data.host || 'https://tilecache.rainviewer.com').replace(/\/$/, '');
  const past = data?.radar?.past || [];
  /** @type {RadarFrame[]} */
  const frames = past.map((f) => ({
    t: Number(f.time),
    path: String(f.path),
    host,
  }));
  await preloadTiles(frames);
  return frames;
}

function tileUrl(frame, z, x, y, size = 512) {
  // Universal Blue-ish scheme id 6; smooth on, snow off
  return `${frame.host}${frame.path}/${size}/${z}/${x}/${y}/6/1_0.png`;
}

/** Preload Israel-relevant tiles at z6–z8 for animation. */
async function preloadTiles(frames) {
  // Israel approx covers a few tiles; warm z7 around Tel Aviv + neighbors
  const specs = [
    [7, 76, 51],
    [7, 75, 51],
    [7, 76, 50],
    [7, 77, 51],
    [7, 76, 52],
    [6, 38, 25],
    [6, 37, 25],
    [8, 152, 103],
    [8, 153, 103],
    [8, 152, 102],
    [8, 153, 102],
  ];
  const jobs = [];
  for (const frame of frames) {
    for (const [z, x, y] of specs) {
      jobs.push(
        fetch(tileUrl(frame, z, x, y)).catch(() => null),
      );
    }
  }
  // Bound concurrency a bit by chunking
  const chunk = 24;
  for (let i = 0; i < jobs.length; i += chunk) {
    await Promise.all(jobs.slice(i, i + chunk));
  }
}

export function radarTileUrl(frame, z, x, y) {
  return tileUrl(frame, z, x, y, 256);
}

export function radarSourceId(index) {
  return `rv-radar-${index}`;
}

export function radarLayerId(index) {
  return `rv-radar-layer-${index}`;
}
